import React from 'react'

export default class Identificacao extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="mt-5 font-weight-bold text-left">
                    2 - IDENTIFICAÇÃO DO PROFISSIONAL:
                </div>
                <div className="form-group row mt-3">
                    <label className="col-3 col-md-2">Profissional Identificado:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="identificacaoProfissional"
                            {...this.props}
                            value={this.props.value.identificacaoProfissional} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    {this.renderPossivel()}
                    <label className="col-12 text-left">Observações:</label>
                    <div className="col-12">
                        <textarea type="textarea" rows="3" className="form-control"
                            name="observacoes"
                            {...this.props}
                            value={this.props.value.observacoes} />
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderPossivel() {
        if (this.props.value.identificacaoProfissional == "Não") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">1. Mais de um possível profissional no Incorp:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="incorp"
                            {...this.props}
                            value={this.props.value.incorp} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">2. Suspeita de exercício ilegal:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="exercicioIlegal"
                            {...this.props}
                            value={this.props.value.exercicioIlegal} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    {this.renderIlegal()}
                </React.Fragment>
            )
        }
        else if (this.props.value.identificacaoProfissional == "Sim") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">CREFITO:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="crefito"
                            {...this.props}
                            value={this.props.value.crefito} />
                    </div>
                    <label className="col-3 col-md-2">Situação:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="situacao"
                            {...this.props}
                            value={this.props.value.situacao} >
                            <option value=""></option>
                            <option value="Não se aplica">Não se aplica</option>
                            <option value="Ativo">Ativo</option>
                            <option value="Baixado">Baixado</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Nome:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="profissionalNome"
                            {...this.props}
                            value={this.props.value.profissionalNome} />
                    </div>
                    <label className="col-3 col-md-2">Identificação do endereço:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="identificacaoEndereco"
                            {...this.props}
                            value={this.props.value.identificacaoEndereco} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    {this.renderEndereco()}
                </React.Fragment>
            )
        }
    }

    renderIlegal() {
        if (this.props.value.exercicioIlegal == "Sim") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">2.1 Possível:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="possivel"
                            {...this.props}
                            value={this.props.value.possivel} >
                            <option value=""></option>
                            <option value="Estudante">Estudante</option>
                            <option value="Leigo">Leigo</option>
                        </select>
                    </div>
                </React.Fragment>
            )
        }
    }

    renderEndereco() {
        if (this.props.value.identificacaoEndereco == "Sim")
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">UF:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="uf"
                            {...this.props}
                            value={this.props.value.uf} >
                            <option value=""></option>
                            <option value="AL">Alagoas</option>
                            <option value="PB">Paraíba</option>
                            <option value="PE">Pernambuco</option>
                            <option value="RN">Rio Grande do Norte</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Município:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="municipio"
                            {...this.props}
                            value={this.props.value.municipio} >
                            <option value=""></option>
                            {this.renderMunicipios()}
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Logradouro:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="logradouro"
                            {...this.props}
                            value={this.props.value.logradouro} />
                    </div>
                </React.Fragment>
            )
    }

    renderMunicipios() {
        let select = []
        this.props.municipios.map(municipio => {
            select.push(<option value={municipio.nome}>{municipio.nome}</option>)
        })
        return select
    }
}